import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import {
  ContentSectionBlock,
  FormInput,
  FormInputText,
  FormInputSelect
} from 'camino-react'

const types = ['Round', 'Boundary', 'Fixed']
const typeOptions = _.map(types, type => ({
  value: `WorkTypeBillingDetails::${type}`,
  label: type
}))

const WorkTypeFormBillingDetails = ({
  regionOptions,
  handleBillingDetailFieldValue,
  billingDetail,
  index
}) => (
  <ContentSectionBlock>
    <FormInput label="Region">
      <FormInputSelect
        options={regionOptions}
        onValue={value => handleBillingDetailFieldValue('region_id', value, index)}
        value={_.find(regionOptions, ['value', billingDetail.region_id])}
      />
    </FormInput>
    <FormInput label="Type">
      <FormInputSelect
        options={typeOptions}
        onValue={value => handleBillingDetailFieldValue('type', value, index)}
        value={_.find(typeOptions, ['value', billingDetail.type])}
      />
    </FormInput>
    <FormInput label="Minimum Time (minutes)">
      <FormInputText
        type="number"
        onValue={value => handleBillingDetailFieldValue('minimum_time', value, index)}
        value={billingDetail.minimum_time}
      />
    </FormInput>
    {billingDetail.type !== 'WorkTypeBillingDetails::Fixed' && (
      <FormInput label="Round by (minutes)">
        <FormInputText
          type="number"
          onValue={value => handleBillingDetailFieldValue('round_by', value, index)}
          value={billingDetail.round_by}
        />
      </FormInput>
    )}
    <FormInput label="Rate multiplier">
      <FormInputText
        type="number"
        step="0.1"
        onValue={value => handleBillingDetailFieldValue('multiplier', value, index)}
        value={billingDetail.multiplier}
      />
    </FormInput>
  </ContentSectionBlock>
)

WorkTypeFormBillingDetails.propTypes = {
  regionOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleBillingDetailFieldValue: PropTypes.func.isRequired,
  billingDetail: PropTypes.shape({
    region_id: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
    minimum_time: PropTypes.string,
    round_by: PropTypes.string
  }).isRequired,
  index: PropTypes.number.isRequired
}

export default WorkTypeFormBillingDetails
